import React, { useEffect, useState } from 'react'
import { Formik } from 'formik'
import { Collapse, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { activityApiService } from '~/services/api'
import { useRcmTableData } from '~/hooks/useRcmTableData'
import persistService from '~/services/persist'
import { Select } from '~/components/Select'
import DateTimePicker from '~/components/DatePicker/DateTimePicker'

const TableFilter: React.FC = () => {
  const { t: translate } = useTranslation()
  const tableData = useRcmTableData()
  const persistanceKey = tableData.persistenceKey + '_filter'
  const defaultFilter = {
    actions: [],
    from: null,
    to: null
  }
  const [filter, setFilter] = useState<any>(null)
  useEffect(() => {
    const persistedFilter = persistService.getBasic(persistanceKey)
    const newFilter = persistedFilter ?? defaultFilter
    setFilter(newFilter)
    doFilter(newFilter)
  }, [])

  const doFilter = (values: any) => {
    tableData.applyFilter({ ...values })
    persistService.setBasic(persistanceKey, { ...values })
  }

  return (
    <Collapse in={tableData.isFilterCollapsed}>
      <div className="filter-wrapper" style={{ marginTop: '2rem' }}>
        {filter && (
          <Formik
            initialValues={{ filter }}
            onReset={(values) => {
              persistService.clear(persistanceKey)
              setFilter(defaultFilter)
              values.filter = defaultFilter
              doFilter(defaultFilter)
            }}
            enableReinitialize={true}
            onSubmit={(values) => {
              doFilter(values.filter)
            }}
          >
            {({ values, setFieldValue, handleSubmit, handleReset }) => (
              <>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group" id="85e88c08-19cb-4dc3-9ae1-9ed1330abf5b">
                      <label>{translate('Action(s)')}</label>
                      <Select
                        placeholder={translate('Actions...')}
                        name="filter.actions"
                        options={(() => {
                          const [actions, setActions] = React.useState<{ value: string; label: string }[]>([])
                          React.useEffect(() => {
                            activityApiService.getUserActions().then((data) => {
                              if (data && Array.isArray(data.elements)) {
                                setActions(data.elements.map((a: any) => ({ value: a.id, label: a.value })))
                              }
                            })
                          }, [])
                          return actions
                        })()}
                        onChange={(option: any) => {
                          setFieldValue('filter.actions', option ? option.map((o: any) => o.value) : [])
                        }}
                        value={values.filter.actions}
                        multi
                        searchable
                        id="85e88c08-19cb-4dc3-9ae1-9ed1330abf5b"
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div>
                      <Form.Label>{translate('REPORTS_FILTER_LABEL_DATETIME_RANGE')}</Form.Label>
                    </div>
                    <div>
                      <Form.Label>{translate('SEARCH_FROM')}</Form.Label>
                      <DateTimePicker
                        name="filter.from"
                        onChange={(val: Date | null) => {
                          if (val) {
                            const dateWithTime = new Date(val)
                            dateWithTime.setHours(0, 0, 0, 0)
                            setFieldValue('filter.from', dateWithTime)
                          } else {
                            setFieldValue('filter.from', val)
                          }
                        }}
                        selected={values.filter.from}
                        showYearDropdown={false}
                        showTimeInput
                        maxDate={new Date()}
                        timeInputLabel={translate('TIME_LABEL_CLINICAL_ACTIVITY_REPORT')}
                        className="form-control field-control pb10 w100p"
                        id="22f9a162-7b28-445e-ad3f-802e13a6c6de"
                      />
                    </div>

                    <div>
                      <Form.Label>{translate('SEARCH_TO')}</Form.Label>
                      <DateTimePicker
                        name="filter.to"
                        onChange={(val: Date | null) => {
                          if (val) {
                            const dateWithTime = new Date(val)
                            dateWithTime.setHours(0, 0, 0, 0)
                            setFieldValue('filter.to', dateWithTime)
                          } else {
                            setFieldValue('filter.to', val)
                          }
                        }}
                        selected={values.filter.to}
                        showYearDropdown={false}
                        showTimeInput
                        maxDate={new Date()}
                        timeInputLabel={translate('TIME_LABEL_CLINICAL_ACTIVITY_REPORT')}
                        className="form-control field-control pb10 w100p"
                        id="22f9a162-7b28-445e-ad3f-802e13a6c6de"
                      />
                    </div>
                  </div>
                </div>
                <div className="clearfix">
                  <div className="pull-left">
                    <button
                      data-action={'filter'}
                      disabled={tableData.isLoading}
                      className="btn btn-primary"
                      onClick={handleSubmit as any}
                      id="7dc09195-02ab-4b84-a785-dd434be97c7c"
                    >
                      {translate('BTN_FILTER')}
                    </button>
                    <button
                      data-action={'reset'}
                      disabled={_.isEqual(defaultFilter, values.filter)}
                      className="btn btn-chita btn-link at-reset"
                      onClick={handleReset as any}
                      id="63d358ca-e229-47ec-9cc8-06d4130a10a3"
                    >
                      {translate('BTN_CLEAR_FILTER')}
                    </button>
                  </div>
                </div>
              </>
            )}
          </Formik>
        )}
      </div>
    </Collapse>
  )
}

export default TableFilter
